"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _Yoast = _interopRequireDefault(require("./Yoast"));

var _jsxFileName = "/opt/build/repo/plugins/wordsby-master/src/components/PageElement.js";

var PageElement = function PageElement(_ref) {
  var children = _ref.children,
      pageContext = _ref.pageContext,
      data = _ref.data,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children", "pageContext", "data"]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Yoast.default, (0, _extends2.default)({}, pageContext, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })), _react.default.cloneElement(children, (0, _extends2.default)({
    data: data,
    pageContext: pageContext
  }, props)));
};

var _default = PageElement;
exports.default = _default;